import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "filter-heading" }
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = { class: "select-values-text-container" }
const _hoisted_4 = {
  key: 0,
  class: "placeholder-text"
}
const _hoisted_5 = {
  key: 1,
  class: "selected-values"
}
const _hoisted_6 = { class: "selected-values__text" }
const _hoisted_7 = { class: "selected-values__count" }
const _hoisted_8 = ["id", "value"]
const _hoisted_9 = ["for"]

import { computed, ref, watch, onMounted, onUnmounted, PropType } from 'vue';
import { useFilterStore } from "../../stores/filterStore";
import { IFilter } from 'interfaces/filter/IFilter';
import ClearButton from '@/components/clear/ClearButton.vue';
import { useSearch } from '@/services/search-service';
import { useFilterState } from '@/services/filter-state-service';
import { useUtil } from '@/services/util-service';


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownFilter',
  props: {
    dataKey: {
        type: [String, Array] as PropType<string | string[]>,
        default: () => []
    },
    placeholder: String,
    title: String
},
  setup(__props) {

const props = __props;

const rootElement = ref<HTMLElement | null>(null);

// We always want to handle dataKey as an array
const dataKeyIsArray = Array.isArray(props.dataKey);
const dataKeys = computed(() => dataKeyIsArray ? props.dataKey : [props.dataKey]);

const { getUniqueValues } = useSearch();
const { updateFilter } = useFilterState();
const { arraysContainTheSameValues } = useUtil();

const dropdownMenu = ref<HTMLElement | null>(null);
const filterStore = useFilterStore();
const selectedValues = ref<string[]>([]);
const showCheckboxes = ref(false);
const uniqueValues = computed(() => getUniqueValues(dataKeys.value ?? ''));

onMounted(() => {
    // Initialize selected values from active filters, they've come as query parameters
    selectedValues.value = filterStore.activeFilters
        .filter((f: IFilter) => f.dataKey === props.dataKey || arraysContainTheSameValues(f.dataKey as string[], dataKeys.value)) // remmember they can be both string or string[]
        .flatMap((f: IFilter) =>
            (Array.isArray(f.value) ? f.value : [f.value])
                .map(v => String(v))); // we only want to handle strings here anyway

    document.addEventListener('click', handleClickOutside, true);
    document.addEventListener('keydown', handleEscape);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside, true);
    document.removeEventListener('keydown', handleEscape);
});

const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as Node | null;
    if (target && rootElement.value && !rootElement.value.contains(target)) {
        showCheckboxes.value = false;
    }
};

const handleEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
        showCheckboxes.value = false;
    }
};

watch(selectedValues, (newValue, oldValue) => {
    if (newValue === oldValue || arraysContainTheSameValues(newValue, oldValue)) {
        return; // No change in selected values
    }

    const filter: IFilter = {
        dataKey: dataKeyIsArray ? dataKeys.value : props.dataKey,
        value: selectedValues.value
    };
    updateFilter(filter);
});

const handleCheckbox = () => {
    showCheckboxes.value = !showCheckboxes.value;
}

function clearFilter() {
    selectedValues.value = [];
}

// Reset min and max if all filters are removed
watch(filterStore.activeFilters, (newFilters )=> {
  if (newFilters.length === 0) {
    clearFilter();
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "filter-component",
    ref_key: "rootElement",
    ref: rootElement
  }, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(__props.title), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "dropdown-select",
        onClick: handleCheckbox,
        onKeyup: _withKeys(handleCheckbox, ["enter"]),
        tabindex: "0"
      }, [
        _createElementVNode("div", _hoisted_3, [
          (!selectedValues.value.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.placeholder), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(selectedValues.value.join(', ')), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_7, _toDisplayString(selectedValues.value.length), 1 /* TEXT */)
              ]))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["dropdown-select__icon icon icon--arrow-down", { 'dropdown-select__icon--open': showCheckboxes.value }])
        }, null, 2 /* CLASS */)
      ], 32 /* NEED_HYDRATION */),
      _withDirectives(_createElementVNode("div", {
        class: "checkbox-list",
        ref_key: "dropdownMenu",
        ref: dropdownMenu
      }, [
        (selectedValues.value.length)
          ? (_openBlock(), _createBlock(ClearButton, {
              key: 0,
              class: "checkbox-list__clear",
              onClick: clearFilter
            }))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueValues.value, (value) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "checkbox",
            key: value
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: `checkbox-${value}`,
              value: value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValues).value = $event))
            }, null, 8 /* PROPS */, _hoisted_8), [
              [_vModelCheckbox, selectedValues.value]
            ]),
            _createElementVNode("label", {
              for: `checkbox-${value}`
            }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_9)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */), [
        [_vShow, showCheckboxes.value]
      ])
    ])
  ], 512 /* NEED_PATCH */))
}
}

})